<template>
  <div
      class="w-full text-slate-100"
      dir="rtl"
  >
    <div style="max-width: 92%" class="w-full mx-auto space-y-2 px-3 sm:px-4 lg:px-6 py-2">
      <div
          class="w-full rounded-3xl border border-white/10
                 bg-gradient-to-br from-slate-950/95 via-slate-900/90 to-slate-950/95
                 backdrop-blur-2xl shadow-2xl shadow-black/40 overflow-hidden"
      >
        <!-- Header -->
        <div class="px-4 md:px-6 py-4 border-b border-white/10 bg-gradient-to-l from-slate-950 via-slate-900 to-indigo-950/25">
          <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div class="flex items-center gap-3 min-w-0">
              <div
                  style="max-width: 50px"
                  class="w-11 h-11  rounded-2xl border border-cyan-400/25 bg-blue-400/10
                         flex items-center justify-center shadow-lg shadow-blue-500/10 flex-shrink-0"
              >
                <svg class="w-5 h-5 text-indigo-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
                </svg>
              </div>

              <div class="min-w-0">
                <h2 class="text-base md:text-lg font-black text-slate-50">
                  لیست سندهای مرجوعی
                </h2>
                <p class="text-xs md:text-sm text-slate-400 mt-1">
                  مشاهده، فیلتر و بررسی جزئیات مرجوعی‌های ثبت‌شده
                </p>
              </div>
            </div>

            <div class="flex items-center gap-2 flex-wrap">
              <div
                  class="text-xs md:text-sm text-slate-300 bg-slate-800/60 px-4 py-2 rounded-2xl border border-white/10"
              >
                نمایش
                <span class="text-indigo-300 font-black mx-1">{{ returns.length }}</span>
                سند
                <template v-if="total">
                  از
                  <span class="text-emerald-300 font-black mx-1">{{ total }}</span>
                </template>
              </div>

              <button
                  type="button"
                  @click="fetchReturns"
                  class="h-10 w-[104px] px-3 rounded-2xl bg-slate-800/80 text-slate-200
                         hover:bg-indigo-400/10 hover:text-indigo-100 hover:border-indigo-400/30
                         text-xs font-bold border border-white/10 transition-all duration-200
                         inline-flex items-center justify-center gap-1.5 flex-none"
              >
                <svg class="w-4 h-4 flex-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4v5h.582M20 20v-5h-.581M5.635 9A7.966 7.966 0 0112 5c2.21 0 4.21.895 5.657 2.343M18.365 15A7.966 7.966 0 0112 19a7.966 7.966 0 01-5.657-2.343"/>
                </svg>
                بروزرسانی
              </button>
            </div>
          </div>
        </div>

        <!-- Filters -->
        <div class="p-4 border-b border-white/10 bg-slate-950/45">
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-12 gap-3 items-end">
            <div class="xl:col-span-3">
              <label class="block text-[11px] text-slate-400 mb-1.5 pr-1">
                شماره فاکتور
              </label>

              <div class="relative">
                <input
                    v-model="filters.order"
                    class="w-full px-4 py-2.5 pl-10 bg-slate-800/80 text-sm rounded-2xl border border-white/10 text-right
                           placeholder-slate-500 focus:outline-none focus:border-indigo-400/50 focus:ring-2 focus:ring-indigo-400/20 transition-all"
                    placeholder="مثلاً 1024"
                    @keyup.enter="applyFilters"
                />

                <svg class="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" fill="none"
                     stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
              </div>
            </div>

            <div class="xl:col-span-5" v-if="false">
              <label class="block text-[11px] text-slate-400 mb-1.5 pr-1">
                بازه تاریخ
              </label>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <input
                    type="date"
                    v-model="filters.date_from"
                    class="w-full px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 text-right
                           focus:outline-none focus:border-indigo-400/50 focus:ring-2 focus:ring-indigo-400/20 transition-all"
                />

                <input
                    type="date"
                    v-model="filters.date_to"
                    class="w-full px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 text-right
                           focus:outline-none focus:border-indigo-400/50 focus:ring-2 focus:ring-indigo-400/20 transition-all"
                />
              </div>
            </div>

            <div class="xl:col-span-4">
              <label class="block text-[11px] text-transparent mb-1.5 pr-1">
                عملیات
              </label>

              <div class="flex items-center justify-start gap-2">
                <button
                    type="button"
                    @click="applyFilters"
                    class="h-[42px] w-[96px] px-3 bg-gradient-to-l from-indigo-400 to-violet-500 text-white text-xs rounded-2xl
                           hover:from-indigo-300 hover:to-violet-400 transition-all duration-200 hover:scale-[1.02]
                           font-black inline-flex items-center justify-center gap-1.5 shadow-lg shadow-indigo-500/15 flex-none"
                >
                  <svg class="w-4 h-4 flex-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"/>
                  </svg>
                  اعمال
                </button>

                <button
                    type="button"
                    @click="clearFilters"
                    class="h-[42px] w-[84px] px-3 bg-slate-800/80 text-slate-300 text-xs rounded-2xl border border-white/10
                           hover:bg-slate-700/80 hover:text-slate-100 transition-all duration-200
                           inline-flex items-center justify-center flex-none"
                >
                  حذف
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="overflow-auto">
          <table class="w-full min-w-[980px] text-sm">
            <thead class="sticky top-0 z-10 bg-slate-950/95 text-slate-300 border-b border-white/10">
            <tr>
              <th class="px-4 py-3 text-center text-xs font-bold">کد مرجوعی</th>
              <th class="px-4 py-3 text-center text-xs font-bold">فاکتور</th>
              <th class="px-4 py-3 text-center text-xs font-bold">ثبت‌کننده</th>
              <th class="px-4 py-3 text-center text-xs font-bold">تاریخ</th>
              <th class="px-4 py-3 text-center text-xs font-bold">مبلغ مرجوعی</th>
              <th class="px-4 py-3 text-center text-xs font-bold">تعداد ردیف</th>
              <th class="px-4 py-3 text-center text-xs font-bold">عملیات</th>
            </tr>
            </thead>

            <tbody class="divide-y divide-white/5">
            <template v-for="doc in returns">
              <tr
                  :key="doc.id"
                  class="hover:bg-slate-800/35 transition-all duration-200"
              >
                <td class="px-4 py-4 text-center">
                  <div
                      class="inline-flex items-center justify-center min-w-[62px] h-9 rounded-2xl
                             bg-cyan-400/10 border border-cyan-400/20 text-cyan-200 font-black text-sm"
                  >
                    #{{ doc.id }}
                  </div>
                </td>

                <td class="px-4 py-4 text-center">
                  <div
                      class="inline-flex items-center justify-center min-w-[62px] h-9 rounded-2xl
                             bg-slate-800/70 border border-white/10 text-slate-100 font-black text-sm"
                  >
                    #{{ doc.order_id }}
                  </div>
                </td>

                <td class="px-4 py-4 text-center">
                  <div class="flex flex-col items-center">
                    <span class="text-slate-100 font-bold text-sm">
                      {{ doc.cashier_name || '---' }}
                    </span>
                    <span
                        v-if="!doc.cashier_name && doc.cashier_id"
                        class="text-slate-500 text-xs mt-1"
                    >
                      #{{ doc.cashier_id }}
                    </span>
                  </div>
                </td>

                <td class="px-4 py-4 text-center whitespace-nowrap">
                  <div class="inline-flex rounded-2xl bg-slate-800/45 border border-white/5 px-3 py-2">
                    <span class="text-slate-300 text-xs">
                      {{ doc.created_at || '---' }}
                    </span>
                  </div>
                </td>

                <td class="px-4 py-4 text-center">
                  <div
                      class="mx-auto w-full max-w-[190px] rounded-2xl border border-amber-400/20
                             bg-amber-400/5 px-3 py-2"
                  >
                    <div class="text-[10px] text-slate-500 mb-1">
                      جمع مرجوعی
                    </div>
                    <div class="text-amber-300 font-black text-sm">
                      {{ money(doc.total_return_amount) }}
                    </div>
                  </div>
                </td>

                <td class="px-4 py-4 text-center">
                  <span
                      class="inline-flex items-center justify-center min-w-[46px] h-8 rounded-2xl
                             bg-indigo-400/10 border border-indigo-400/20 text-indigo-200 font-black text-xs"
                  >
                    {{ (doc.items || []).length }}
                  </span>
                </td>

                <td class="px-4 py-4 text-center whitespace-nowrap">
                  <button
                      type="button"
                      @click="toggleExpand(doc)"
                      class="h-9 w-[92px] px-3 rounded-2xl bg-slate-800/80 text-slate-200
                             hover:bg-indigo-400/10 hover:text-indigo-100 hover:border-indigo-400/30
                             text-xs border border-white/10 transition-all duration-200
                             inline-flex items-center justify-center gap-1.5 flex-none"
                  >
                    <svg
                        class="w-4 h-4 transition-transform duration-200"
                        :class="expandedId === doc.id ? 'rotate-180' : ''"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 9l-7 7-7-7"/>
                    </svg>
                    {{ expandedId === doc.id ? 'بستن' : 'جزئیات' }}
                  </button>
                </td>
              </tr>

              <!-- Expanded -->
              <tr
                  v-if="expandedId === doc.id"
                  :key="'expand-' + doc.id"
                  class="bg-slate-950/50"
              >
                <td colspan="7" class="px-4 md:px-6 py-4">
                  <div class="rounded-3xl border border-white/10 bg-slate-950/70 overflow-hidden shadow-xl shadow-black/20">
                    <div class="px-4 py-3 border-b border-white/10 bg-slate-900/70">
                      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                        <div>
                          <div class="text-xs font-bold text-slate-200">
                            جزئیات سند مرجوعی #{{ doc.id }}
                          </div>
                          <div class="text-[11px] text-slate-500 mt-1">
                            فاکتور مرتبط: #{{ doc.order_id }}
                          </div>
                        </div>

                        <div
                            class="inline-flex items-center justify-center px-3 py-1.5 rounded-2xl
                                   border border-amber-400/20 bg-amber-400/5 text-amber-300 text-xs font-black"
                        >
                          {{ money(doc.total_return_amount) }}
                        </div>
                      </div>

                      <div class="mt-3 rounded-2xl bg-slate-950/60 border border-white/5 px-3 py-2 text-xs text-slate-400">
                        {{ doc.note || 'بدون توضیحات' }}
                      </div>
                    </div>

                    <div class="overflow-auto">
                      <table class="w-full min-w-[650px] text-xs">
                        <thead class="bg-slate-950 text-slate-400">
                        <tr>
                          <th class="px-3 py-2.5 text-right">کالا</th>
                          <th class="px-3 py-2.5 text-center">تعداد</th>
                          <th class="px-3 py-2.5 text-center">قیمت واحد</th>
                          <th class="px-3 py-2.5 text-center">جمع</th>
                        </tr>
                        </thead>

                        <tbody class="divide-y divide-white/5">
                        <tr
                            v-for="item in doc.items || []"
                            :key="item.id"
                            class="hover:bg-slate-800/30"
                        >
                          <td class="px-3 py-3 text-slate-100">
                            <div class="flex flex-col">
                              <span class="font-bold">
                                {{ item.product_name || '---' }}
                              </span>
                              <span class="text-slate-500 mt-1">
                                کد کالا: #{{ item.product_id || '---' }}
                              </span>
                            </div>
                          </td>

                          <td class="px-3 py-3 text-center text-slate-200">
                            <span
                                class="inline-flex items-center justify-center min-w-[38px] h-7 rounded-xl
                                       bg-slate-800/70 border border-white/10 font-bold"
                            >
                              {{ item.quantity }}
                            </span>
                          </td>

                          <td class="px-3 py-3 text-center text-slate-300">
                            {{ money(item.unit_price) }}
                          </td>

                          <td class="px-3 py-3 text-center text-amber-300 font-black">
                            {{ money(item.line_total) }}
                          </td>
                        </tr>

                        <tr v-if="!(doc.items || []).length">
                          <td colspan="4" class="px-4 py-8 text-center text-slate-500">
                            آیتمی برای این سند ثبت نشده است.
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            </template>

            <tr v-if="!returns.length && !loading">
              <td colspan="7" class="px-6 py-16 text-center">
                <div class="flex flex-col items-center justify-center text-slate-500">
                  <div
                      class="w-20 h-20 rounded-3xl border border-white/10 bg-slate-800/40
                             flex items-center justify-center mb-4"
                  >
                    <svg class="w-10 h-10 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
                    </svg>
                  </div>

                  <p class="text-lg font-black text-slate-300">
                    سند مرجوعی‌ای یافت نشد
                  </p>
                  <p class="text-sm mt-2 text-slate-500">
                    هیچ سندی مطابق با فیلترهای فعلی وجود ندارد
                  </p>
                </div>
              </td>
            </tr>

            <tr v-if="loading">
              <td colspan="7" class="px-6 py-14 text-center">
                <div class="flex flex-col items-center justify-center text-slate-400">
                  <div class="w-9 h-9 rounded-full border-2 border-slate-700 border-t-indigo-400 animate-spin mb-3"></div>
                  <p class="text-sm">
                    در حال دریافت لیست مرجوعی‌ها...
                  </p>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer -->
        <div
            class="px-4 py-3 border-t border-white/10 bg-slate-950/55
                   flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-slate-400"
        >
          <div>
            نمایش
            <span class="text-indigo-300 font-black mx-1">{{ returns.length }}</span>
            سند
            <span v-if="total">
              از
              <span class="text-emerald-300 font-black mx-1">{{ total }}</span>
            </span>
          </div>

          <div v-if="error" class="text-rose-300 font-bold">
            {{ error }}
          </div>

          <div v-else class="text-slate-500">
            آخرین وضعیت لیست مرجوعی‌های فروش حضوری
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosReturnsListTab',

  props: {
    apiGetPos: {
      type: Function,
      required: true
    },
    formatCurrency: {
      type: Function,
      default: null
    },
    toast: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      returns: [],
      total: 0,
      loading: false,
      error: '',
      expandedId: null,
      filters: {
        order: '',
        date_from: '',
        date_to: ''
      }
    }
  },

  created() {
    this.fetchReturns()
  },

  methods: {
    async fetchReturns() {
      this.loading = true
      this.error = ''

      try {
        const params = {}

        if (this.filters.order) params.order = this.filters.order
        if (this.filters.date_from) params.date_from = this.filters.date_from
        if (this.filters.date_to) params.date_to = this.filters.date_to

        const data = await this.apiGetPos('order-returns/', params)

        if (Array.isArray(data)) {
          this.returns = data
          this.total = data.length
        } else {
          this.returns = data.results || []
          this.total = data.count || this.returns.length
        }
      } catch (e) {
        this.error = this.extractError(e) || 'دریافت لیست مرجوعی‌ها انجام نشد'

        if (this.toast) {
          this.toast(this.error)
        }
      } finally {
        this.loading = false
      }
    },

    applyFilters() {
      this.expandedId = null
      this.fetchReturns()
    },

    clearFilters() {
      this.filters = {
        order: '',
        date_from: '',
        date_to: ''
      }
      this.expandedId = null
      this.fetchReturns()
    },

    toggleExpand(doc) {
      this.expandedId = this.expandedId === doc.id ? null : doc.id
    },

    money(value) {
      if (this.formatCurrency) return this.formatCurrency(value)
      const num = Number(value || 0)
      if (Number.isNaN(num)) return value || '0'
      return num.toLocaleString('fa-IR') + ' تومان'
    },

    extractError(e) {
      const data = e && e.response && e.response.data ? e.response.data : e
      if (!data) return ''
      if (typeof data === 'string') return data
      if (data.detail) return data.detail
      if (data.error) return data.error
      try {
        return Object.values(data).flat().join('، ')
      } catch (_) {
        return ''
      }
    }
  }
}
</script>